import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { ThemeOptions } from '../publicSession/types';
import { getForcedGlobalClassnamesForContext } from './helpers';
export var ThemeContext = React.createContext(undefined);
// HOC for convenience...
export var withThemeContext = function (Component) { return function (props) {
    return (React.createElement(ThemeContext.Consumer, null, function (theme) { return React.createElement(Component, __assign({ theme: theme }, props)); }));
}; };
// and for overriding theme...
export var ThemeOverride = function (_a) {
    var children = _a.children, theme = _a.theme, className = _a.className;
    return (React.createElement(ThemeContext.Provider, { value: theme },
        React.createElement("span", { className: classnames(className, getForcedGlobalClassnamesForContext({
                theme: theme,
            })) }, children)));
};
ThemeOverride.displayName = 'ThemeOverride';
export var ReverseTheme = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(ThemeContext.Consumer, null, function (theme) {
        var flippedTheme = theme === ThemeOptions.LIGHT ? ThemeOptions.DARK : ThemeOptions.LIGHT;
        return (React.createElement(ThemeContext.Provider, { value: flippedTheme },
            React.createElement("span", { className: classnames(className, getForcedGlobalClassnamesForContext({
                    theme: flippedTheme,
                })) }, children)));
    }));
};
ReverseTheme.displayName = 'ReverseTheme';
//# sourceMappingURL=ThemeContext.js.map